import SEO from '../../Components/SEO';
import Breadcrumb from '../../Components/Breadcrumb';
import { ActivityLayout } from '../../Components/activity-layout';

const speaking = '/Images/speaking3.webp';

const levels = [
  {
    level: 'B2',
    cards: [
      {
        title: 'Speaking Topics',
            image: '/Images/speaking3.webp',
        level: 'B2',
        desc:
          'Vocabulary exercises, flashcards and quizzes to help you improve and have greater success on exams.',
        links: [
          {
            text: 'Speaking Topics',
            to: '/speaking-exercises/speaking-topics',
            level: 'B2',
          },
        ],
      },
      {
        title: 'Picture Comparison',
        image: '/Images/steps1.webp',
        level: 'B2',
        desc:
          'Vocabulary exercises, flashcards and quizzes to help you improve and have greater success on exams.',
        links: [
          {
            text: 'Picture Comparison',
            to: '/speaking-exercises/picture-comparison',
            level: 'B2',
          },
        ],
      },
    ],
  },
];

const Speakingexercises = () => {
  return (
      <ActivityLayout
        title="Speaking Exercises"
        image={speaking}
        intro="Here is a collection of speaking exercises to do. The exercises are divided by categories which correspond to exam levels. Each category here has 10 exercises, but there are more once you go to the page. Keep checking back as I am always adding new exercises."
        levels={levels}
      >
      <SEO
        title='Free English Speaking Exercises and Practice'
        description='Free speaking exercises and exam-style prompts organised by CEFR level. Practise describing pictures and answering topic questions for Cambridge English, IELTS and other English speaking tests.'
        name='English Exam Exercises'
        type='article'
        image={speaking} />
      <Breadcrumb />
    </ActivityLayout>
  );
};

export default Speakingexercises;
